import React, { useState, useEffect, useCallback } from 'react'
import AppSidebar from '../../components/AppSidebar'
import AppHeader from "../../components/AppHeader"
import PageHeader from '../../components/PageHeader'
import { BsFillTrashFill } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { Link, NavLink } from 'react-router-dom';
import GroupService from '../../services/GroupService';
import ConfirmModal from "../../modals/ConfirmModal";
import { toast, ToastContainer } from "react-toastify";
import ViewGroupModal from './ViewGroupModal';
import Pagination from '../../components/Pagination';
import UseDebounce from '../../hooks/UseDebounce';
import { PageLimit } from '../../utils/ConstantUtils';
import { DebounceDelay } from '../../utils/ConstantUtils';
import Filters from '../../components/Filters';

const ListGroup = () => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [alert, setAlert] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [groupId, setGroupId] = useState(null);
    const [moduleType, setModuleType] = useState(null);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const pageLimit = PageLimit;
    const [itemsPerPage, setPageLimit] = useState(pageLimit);
    const offset = (currentPage - 1) * itemsPerPage;
    const [appliedFilters, setAppliedFilters] = useState({});
    const debouncedSearchTerm = UseDebounce(searchTerm, DebounceDelay || 100);

    const fetchGroups = useCallback(async () => {
        try {
            const response = await GroupService.getAll({
                page: currentPage,
                limit: itemsPerPage,
                search: debouncedSearchTerm,
                offset: offset,
                filters: appliedFilters,
            });
            if (response.status === 200) {
                setRows(response?.data?.data?.groups);
                setTotalPages(response?.data?.data?.totalPages);
                setCurrentPage(response?.data?.data?.currentPage);
            }
        } catch (error) {
            setError(error.message);
            setLoading(false);
            setAlert(true);
        } finally {
            setLoading(false);
        }
    },[currentPage, itemsPerPage, debouncedSearchTerm, offset, appliedFilters]);

    const handleCancel = () => {
        setShowConfirmModal(false);
    }
    const handleClose = () => {
        setShowViewModal(false);
    }

    useEffect(() => {
        fetchGroups();
    }, [appliedFilters, fetchGroups])

    const handleEditClick = (row) => {
        setSelectedGroup(row);
        setShowViewModal(true);
        console.log(row);
    }
    const handleDeleteClick = (row) => {
        setModuleType('group');
        setGroupId(row.id);
        setShowConfirmModal(true);
        console.log(row);
    }
    const handleDelete = async (id) => {
        if (!id) return;
         try {
             const response = await GroupService.delete(id);
             if (response.status === 200) {
                 toast.success(response?.data?.message);
                 fetchGroups();
                 setShowConfirmModal(false);
             } else {
                 console.error("Error in deleting group", response);
                 toast.error(response?.data?.message);
             }
         } catch (error) {
             setError(error);
             toast.error(error.message);
             console.log("Error in deleting group", error);
         }
     };

     const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (e) => {
        setCurrentPage(1);
        setPageLimit(e.target.value);
    };
    const filterFields = [
        { name: "name", placeholder: "Name", Dropdown : "yes"  },
        { name: "label", placeholder: "Label", Dropdown : "yes"  },
        { name: 'status', placeholder: 'Status' , Dropdown : "yes" },

    ];
    const handleApplyFilters = (filters) => {
        setAppliedFilters(filters);
        console.log("Applied Filters:", filters);
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader/>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 ">
                            <PageHeader title="Groups" button_label="Create" link_to="create" className="btn btn-sm btn-primary" />
                            {alert && (
                                <div className="alert alert-danger alert-dismissible fade show" role="alert">
                                    <strong> {error}!</strong>
                                    <button type="button" onClick={() => setAlert(false)} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                                </div>
                            )}
                            <div className="tab-content">
                                <div className="tab-pane fade show active" id="contactsListPane" role="tabpanel" aria-labelledby="contactsListTab">
                                    <div className="card">
                                    <div className="card-header">
                                            <div className="row align-items-center">
                                                <div className="col">
                                                    <form>
                                                        <div className="input-group input-group-flush input-group-merge input-group-reverse">
                                                            <input
                                                                className="form-control list-search"
                                                                type="text"
                                                                placeholder="Search"
                                                                value={searchTerm}
                                                                onChange={handleSearchChange}
                                                            />
                                                            <span className="input-group-text">
                                                                <i className="fe fe-search" />
                                                            </span>
                                                        </div>
                                                    </form>
                                                </div>
                                                <div className="col-auto me-n3">
                                                    <form>
                                                        <select
                                                            className="form-select form-select-sm form-control-flush"
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                        >
                                                            <option value="20">20 per page</option>
                                                            <option value="40">40 per page</option>
                                                            <option value="60">60 per page</option>
                                                            <option value="100">100 Records</option>
                                                        </select>
                                                    </form>
                                                </div>
                                                <div className="col-auto">
                                                <Filters filterFields={filterFields} onApplyFilters={handleApplyFilters} getFilterService={GroupService.getGroupFilter} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive">
                                            {loading && (
                                                <div className="text-center">Loading...</div>
                                            )}
                                            <table className="table table-sm table-nowrap">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Name</th>
                                                        <th scope="col">Label</th>
                                                        <th scope="col">Status</th>
                                                        <th scope="col">Description</th>
                                                        <th scope="col">Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(rows) && rows.length > 0 ? (
                                                        rows.map((row, index) => (
                                                            <tr key={row.id}>
                                                                <th scope="row">{offset + index + 1}</th>
                                                                <td> <NavLink to={`/groups/${row.id}/edit`}>{row.name}</NavLink></td>
                                                                <td>{row?.label}</td>
                                                                <td><span className={`badge bg-${row.status === 'active' ? 'success' : 'danger'}`}>{row.status}</span></td>
                                                                <td>{row?.description}</td>
                                                                <td><Link to='' onClick={() => handleEditClick(row)}><FaEye /></Link> </td>

                                                                {/* | <Link to='' onClick={() => handleDeleteClick(row)}><BsFillTrashFill /></Link> */}
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="6" className="text-center">No data available</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <Pagination {...{ currentPage, totalPages, setCurrentPage }} className="pagination justify-content-end" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ViewGroupModal data={selectedGroup} show={showViewModal} handleClose={handleClose }/>
            { showConfirmModal &&(
                        <ConfirmModal
                        show={showConfirmModal}
                        onCancel={handleCancel}
                        onConfirm={handleDelete}
                        id={groupId}
                        type={moduleType}
                        heading="Delete Group"
                        content={"Are you sure you want to delete this group?"}
                        />
                    )
                }
            <ToastContainer />
        </>
    )
}

export default ListGroup